import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getOrFail } from 'mythil/object';
import MainApp from './MainApp';
// import GridTest from "../../test/GridTest";
// import Test from "../../test/DomNodeTest";
// import ChildTest from "../../test/ChildTest";
// import TypographyTest from "~/test/TypographyTest";
import 'react-quill/dist/quill.bubble.css';
import '~/css/quill.css';
import './default.css';
import { GlobalErrorBoundary } from './GlobalErrorBoundary';

const pages = {
    app: (<MainApp />),
    // test: (<Test />),
    // testgrid: (<GridTest />),
    // testchild: (<ChildTest />),
    // testtypography: (<TypographyTest />)
};

export class App extends Component {
    static propTypes = {
        page: PropTypes.string.isRequired,
    };

    componentWillMount() {

    }

    render() {
        return (
            <GlobalErrorBoundary>
                { getOrFail(pages, this.props.page, `Failed to get page ${this.props.page}`, pages) }
            </GlobalErrorBoundary>
        )
    }
};

const RXApp = connect((state) => ({
    page: state.page
}), () => ({

}))(App);

export default RXApp;